import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Box } from "@similarweb/ui-components";

import { DefaultCellHeaderRightAlign } from "app/components/React/Table/headerCells";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const BoxContainer = styled(Box)<{ addMarginRight?: boolean }>`
    margin-right: ${({ addMarginRight }) => (addMarginRight ? "20px" : "0px")};
    height: min-content;
    width: auto;
    margin-bottom: 24px;
    flex: 1 0 350px;
    display: flex;
    flex-direction: column;
    position: relative;
`;
export const TitleContainer = styled(FlexRow)`
    justify-content: space-between;
    padding: 20px 24px;
`;

export const LoaderContainer = styled.div`
    height: 181px;
`;

export const SearchOverviewListContentWrapper = styled.div`
    height: auto;
    .MiniFlexTable {
        padding-bottom: 0;
    }
    && {
        .MiniFlexTable-container .MiniFlexTable-column .MiniFlexTable-headerCell,
        .MiniFlexTable-container .MiniFlexTable-column .MiniFlexTable-cell {
            display: flex;
            align-items: center;
            padding: 0 0 0 12px;
            box-sizing: border-box;
        }
    }
    .MiniFlexTable-container .MiniFlexTable-column .MiniFlexTable-cell {
        height: 40px;
        font-size: 14px;
        line-height: 16px;
        border-bottom: 1px solid ${colorsPalettes.carbon["50"]};
    }
    .MiniFlexTable-container .MiniFlexTable-column .MiniFlexTable-cell.outgoingTraffic-cell {
        justify-content: flex-end;
        padding-right: 12px;
    }
    .MiniFlexTable-container .MiniFlexTable-column .MiniFlexTable-cell:last-child {
        border-bottom: initial;
    }
    .MiniFlexTable-container .MiniFlexTable-column .MiniFlexTable-headerCell {
        height: 32px;
        font-size: 12px;
        color: ${colorsPalettes.carbon[300]};
        font-weight: 500;
        border-bottom: 1px solid ${colorsPalettes.carbon["50"]};
    }
    .changePercentage,
    ${DefaultCellHeaderRightAlign} {
        width: 100%;
        padding-right: 12px;
    }
`;
